export default class Task {
  constructor(data) {
    if(!data) {
      data = {};
    }
    this._id = data._id;
    this.workload = data.workload;
    this.summary = data.summary;
    this.description = data.description;
    this.checked = data.checked;
  }
}
